import { ApiResponseError } from "./api-response-error.model";

/*
    Class encapsulate the response that a service receives from remote api calls.
    Except for base service we should not throw any other exception, the caller only expects
    an instance of this class with proper messages in the error
*/
export class ApiResponse<T> {
    data?: T;
    hasError: boolean;
    error: Array<ApiResponseError>;

    constructor() {
        this.error = new Array<ApiResponseError>();
    }

    addKey(key: string): ApiResponseError {
        let e = new ApiResponseError();
        e.key = key;
        this.hasError = true;
        this.error.push(e);
        return e;
    }

    public prepareForNonStandard(): void {
        this.hasError = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/client-core/api-response-models/api-response.model.ts